
export class Result<T extends any> 
{
    private ResultValue : T | undefined;
    private ErrorValue : Error | undefined;

    private constructor(value? : T, err? : Error) {
        this.ResultValue = value;
        this.ErrorValue = err;
    }

    public static makeError<T extends any>(err: Error) {
        return new Result<T>(undefined, err);
    }

    public static makeSuccess<T extends any>(value: T) {
        return new Result<T>(value, undefined);
    }

    public match<TO extends any>(okHandler : (value : T) => TO, errHandler : (err : Error) => TO)
    {
        if (this.ResultValue !== undefined) {
            return okHandler(this.ResultValue);
        } else {
            return errHandler(this.ErrorValue!);
        }
    }

	/**
	 * Try to unpack the result value.
	 * May return undefined if contains an error
	 */
	public unpack() : T | undefined {
		return this.ResultValue;
	}

	/**
	 * Try to get the Error if any
	 */
	public error() : Error | undefined {
		return this.ErrorValue;
	}
}
